export const blockHeights: Record<string, string> = {
	card: '830px',
	banner: '287px',
	'banner-timer': '346px',
	cover: '600px',
	'lead-form': '544px',
	'lead-form-horizontal-half': '588px',
	'lead-form-half': '636px',
	'lead-form-mod': '577px',
	'lead-form-contact': '618px',
	'lead-form-vertical': '680px',
	'banner-device': '486px',
	'banner-half': '636px',
	'banner-telegram': '216px',
	'banner-text': '333px',
	'banner-full': '446px',
	map: '626px',
	'map-contact': '596px',
	'map-contact-mod': '756px',
	contact: '434px',
	'contact-mod': '449px',
	'contact-info': '522px',
	'contact-image': '596px',
	'company-details': '904px',
	statistic: '226px',
	'statistic-mod': '226px',
	marketing: '1187px',
	'marketing-small': '1093px',
	'marketing-small-light': '936px',
	'marketing-slider': '671px',
	'marketing-mod': '1024px',
	'marketing-light': '1024px',
	'benefits-icons': '909px',
	'benefits-slider': '682px',
	'benefits-icons-horizontal': '1504px',
	benefits: '610px',
	'benefits-numbers': '680px',
	'benefits-history': '686px',
	media: '797px',
	gallery: '490px',
	'gallery-before': '968px',
	'gallery-slider': '819px',
	'gallery-mosaic': '498px',
	'gallery-inst': '754px',
	'gallery-horizontal': '730px',
	service: '468px',
	'service-mod': '496px',
	rates: '570px',
	'rates-light': '549px',
	'rates-horizontal': '827px',
	'rst-poll': '80vh',
	goods: '933px',
	'goods-text': '773px',
	'goods-text-card': '918px',
	faq: '462px',
	'faq-table': '1982px',
	'faq-open': '1950px',
	'text-small': '359px',
	'text-col': '339px',
	table: '384px',
	quote: '359px',
	paragraph: '298px',
	list: '570px',
	description: '613px',
	conditions: '585px',
	form: '261px',
	'schedule-time': '805px',
	'schedule-date': '483px',
	'reviews-slider': '823px',
	'reviews-slider-alt': '744px',
	'reviews-mod': '4762px',
	reviews: '685px',
	'reviews-blocks': '1265px',
	quiz: '287px',
	'quiz-open': '855px',
	'partner-light': '342px',
	'partner-contact': '578px',
	partner: '498px',
	'presentation-group-mod': '1392px',
	'presentation-group': '2030px',
	presentation: '722px',
	'presentation-50': '581px',
	'images-block': '1457px',
	'simple-block': '1278px',
	other: '979px',
	instagram: '189px',
	html: '189px',
	main: '1020px',
}
